import type { Meta, StoryObj } from "@storybook/react";

import type { SMTEntryImagePreviewProps } from "@/ui/components/smt/ViewSMTEntries/SMTEntryImagePreview";
import SMTEntryImagePreview from "@/ui/components/smt/ViewSMTEntries/SMTEntryImagePreview";

const mockImageUrl = "https://picsum.photos/400";

const StoryMeta: Meta<SMTEntryImagePreviewProps> = {
  title: "Components/SMT/SMT Entry Image Preview",
  component: SMTEntryImagePreview,
  args: {
    testID: "smt-entry-image-preview",
  },
};

type Story = StoryObj<SMTEntryImagePreviewProps>;

const WithImage: Story = {
  args: {
    isUploading: false,
    previewImageUrl: mockImageUrl,
  },
};

const Uploading: Story = {
  args: {
    isUploading: true,
    previewImageUrl: undefined,
  },
};

const UploadingWithImage: Story = {
  args: {
    isUploading: true,
    photoUrl: mockImageUrl,
    previewImageUrl: mockImageUrl,
  },
};

const NoImage: Story = {
  args: {
    isUploading: false,
    previewImageUrl: undefined,
  },
};

export { NoImage, Uploading, UploadingWithImage, WithImage };
export default StoryMeta;
